// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__17ab9","tab-content":"tabs_tab-content__2uO11","tab-list":"tabs_tab-list__NBUxB","tab-list--position-right":"tabs_tab-list--position-right__7Zqj3"};